export enum ProficiencyEnum {
  NOTIONS = 'NOTIONS',
  INTERMEDIATE = 'INTERMEDIATE',
  PROFESSIONAL = 'PROFESSIONAL',
  NATIVE_LANGUAGE = 'NATIVE_LANGUAGE',
}
